import { FC, PropsWithChildren } from 'react';

import { IonListHeader } from '@ionic/react';
import classNames from 'classnames';
import { useContextSelector } from 'use-context-selector';

import { SectionContext } from '../Section.context';
import { Icon } from '../../Icon';

import styles from './SectionHeader.module.scss';

type SectionHeaderProps = PropsWithChildren<{
  className?: string;
}>;

export const SectionHeader: FC<SectionHeaderProps> = ({
  children,
  className,
}) => {
  const collapsible = useContextSelector(
    SectionContext,
    ({ collapsible }) => collapsible
  );

  const value = useContextSelector(SectionContext, ({ value }) => value);

  return (
    <IonListHeader
      slot="header"
      className={classNames(
        styles.root,
        {
          [styles.collapsible]: collapsible,
        },
        className
      )}
    >
      {children}
      {collapsible && (
        <Icon
          name="chevron-down"
          className={classNames(styles.icon, {
            [styles.expanded]: !!value,
          })}
        />
      )}
    </IonListHeader>
  );
};
